import React from 'react';

import './App.css';
import { AuthProvider, useAuth } from "./hooks/useAuth";
import Register from "./screens/Register";
import Home     from "./screens/Home";
import Admin    from "./screens/Admin";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AppContent() {
  const { user } = useAuth();
  if (!user)             return <Register />;
  if (user.role==="admin") return <Admin />;
  return <Home />;
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
      <ToastContainer position="top-center" />
    </AuthProvider>
  );
}

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;
